var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterKnockout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Twitter-knockout") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Twitter-knockout",
    stroke: "none",
    strokeWidth: 1,
    fill: "#00265f",
    fillRule: "evenodd",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "Twiiter",
    transform: "translate(0.953000, 1.020000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.244,14.622 C29.244,22.697 22.698,29.243 14.622,29.243 C6.547,29.243 0,22.697 0,14.622 C0,6.546 6.547,0 14.622,0 C22.698,0 29.244,6.546 29.244,14.622",
    id: "Fill-105",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.701,9.612 C22.194,9.841 21.634,9.98 21.088,10.072 C21.347,10.028 21.728,9.559 21.881,9.369 C22.114,9.079 22.307,8.749 22.416,8.393 L22.413,8.309 L22.327,8.316 C21.717,8.643 21.086,8.879 20.414,9.047 L20.283,9.013 L20.116,8.842 C19.833,8.602 19.531,8.413 19.19,8.274 C18.742,8.091 18.251,8.014 17.769,8.045 C17.299,8.076 16.838,8.208 16.421,8.426 C16.003,8.644 15.631,8.948 15.334,9.314 C15.027,9.693 14.801,10.14 14.685,10.614 C14.573,11.072 14.582,11.525 14.651,11.987 L14.584,12.064 C11.958,11.673 9.782,10.734 8.014,8.72 C7.938,8.632 7.896,8.632 7.833,8.727 C7.06,9.886 7.435,11.748 8.401,12.663 C8.53,12.785 8.663,12.907 8.805,13.018 C8.752,13.029 8.11,12.959 7.537,12.663 L7.414,12.729 C7.408,12.855 7.418,12.97 7.436,13.106 C7.584,14.281 8.398,15.368 9.512,15.791 C9.645,15.847 9.79,15.896 9.933,15.92 C9.679,15.976 9.418,16.016 8.69,15.959 C8.599,15.941 8.565,15.987 8.599,16.074 C9.147,17.565 10.328,18.009 11.212,18.262 C11.33,18.282 11.449,18.282 11.568,18.31 L11.546,18.331 C11.253,18.778 10.236,19.111 9.762,19.277 C8.901,19.578 7.963,19.713 7.052,19.624 C6.907,19.602 6.876,19.604 6.836,19.624 L6.878,19.721 C7.063,19.843 7.251,19.951 7.443,20.056 C8.021,20.362 8.623,20.606 9.254,20.78 C12.509,21.679 16.176,21.018 18.621,18.59 C20.54,16.683 21.213,14.053 21.213,11.419 C21.213,11.316 21.334,11.26 21.407,11.205 C21.907,10.83 22.309,10.381 22.682,9.879 C22.765,9.767 22.766,9.667 22.766,9.625 L22.766,9.612 L22.701,9.612",
    id: "Fill-106",
    fill: "#FFFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterKnockout);
export default __webpack_public_path__ + "static/media/Twitter-knockout.b63d7fdc737b28005e473437d9719681.svg";
export { ForwardRef as ReactComponent };